import { render, staticRenderFns } from "./DesvincularDoc.vue?vue&type=template&id=24ce47a7&scoped=true&lang=pug&"
import script from "./DesvincularDoc.vue?vue&type=script&lang=js&"
export * from "./DesvincularDoc.vue?vue&type=script&lang=js&"
import style0 from "./DesvincularDoc.vue?vue&type=style&index=0&id=24ce47a7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce47a7",
  null
  
)

export default component.exports